import { render } from "./ListeConsultation.vue?vue&type=template&id=3183bb2c&scoped=true"
import script from "./ListeConsultation.vue?vue&type=script&lang=js"
export * from "./ListeConsultation.vue?vue&type=script&lang=js"

import "./ListeConsultation.vue?vue&type=style&index=0&id=3183bb2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3183bb2c"]])

export default __exports__